import Axios from "../config/Axios";
import {
    GENERATE_LINKEDINAD_REQUEST,
    GENERATE_LINKEDINAD_SUCCESS,
    GENERATE_LINKEDINAD_FAIL,
    GENERATE_TAGLINE_REQUEST,
    GENERATE_TAGLINE_SUCCESS,
    GENERATE_TAGLINE_FAIL,
    GENERATE_GOOGLEAD_REQUEST,
    GENERATE_GOOGLEAD_SUCCESS,
    GENERATE_GOOGLEAD_FAIL,
    GENERATE_AMAZONDESC_REQUEST,
    GENERATE_AMAZONDESC_SUCCESS,
    GENERATE_AMAZONDESC_FAIL,
    GENERATE_BLOGOUTLINE_REQUEST,
    GENERATE_BLOGOUTLINE_SUCCESS,
    GENERATE_BLOGOUTLINE_FAIL,
    GENERATE_BLOGIDEAS_REQUEST,
    GENERATE_BLOGIDEAS_SUCCESS,
    GENERATE_BLOGIDEAS_FAIL,
    GENERATE_BLOGQUOTE_REQUEST,
    GENERATE_BLOGQUOTE_SUCCESS,
    GENERATE_BLOGQUOTE_FAIL,
    GENERATE_BLOGINTRO_REQUEST,
    GENERATE_BLOGINTRO_SUCCESS,
    GENERATE_BLOGINTRO_FAIL,
    GENERATE_DISPLAYADS_REQUEST,
    GENERATE_DISPLAYADS_SUCCESS,
    GENERATE_DISPLAYADS_FAIL,
    GENERATE_FAQ_REQUEST,
    GENERATE_FAQ_SUCCESS,
    GENERATE_FAQ_FAIL,
    GENERATE_PAINAGITATE_REQUEST,
    GENERATE_PAINAGITATE_SUCCESS,
    GENERATE_PAINAGITATE_FAIL,
    GENERATE_FACEBOOKAD_REQUEST,
    GENERATE_FACEBOOKAD_SUCCESS,
    GENERATE_FACEBOOKAD_FAIL,

    
} from '../constants/generateConstants';

const genrateLinkedInAdd = (companyName, companyDesc) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_LINKEDINAD_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        let inputVal = companyName + " " + companyDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/linkedinadd", { "prompt": inputVal }, config);

        dispatch({
            type: GENERATE_LINKEDINAD_SUCCESS,
            payload: {
                resultData: data.choices,
                companyName,
                companyDesc
            }
        })

        // localStorage.removeItem('linkedinAd');
        // localStorage.setItem('linkedinAd', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_LINKEDINAD_FAIL,
            payload: error.message,
        })
    }
}

const saveLinkedInAd = (companyName, resultData, companyDesc) => async (dispatch) => {
    dispatch({
        type: GENERATE_LINKEDINAD_SUCCESS,
        payload: {
            resultData,
            companyName,
            companyDesc
        }
    })

    // localStorage.setItem('linkedinAd', JSON.stringify({
    //     resultData,
    //     companyName
    // }))
}

const genrateTagline = (companyName, companyDesc) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_TAGLINE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        let inputVal = companyName + " " + companyDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/tagline", { "prompt": inputVal }, config);

        dispatch({
            type: GENERATE_TAGLINE_SUCCESS,
            payload: {
                resultData: data.choices,
                companyName,
                companyDesc
            }
        })

        // localStorage.removeItem('tagline');

        // localStorage.setItem('tagline', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_TAGLINE_FAIL,
            payload: error.message,
        })
    }
}

const saveTagline = (companyName, resultData, companyDesc) => async (dispatch) => {
    dispatch({
        type: GENERATE_TAGLINE_SUCCESS,
        payload: {
            resultData,
            companyName,
            companyDesc
        }
    })

    // localStorage.setItem('tagline', JSON.stringify({
    //     resultData,
    //     companyName
    // }))
}

const genrateGoogleAdd = (companyName, adDesc, websiteURL) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_GOOGLEAD_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        let inputVal = companyName + " " + adDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/googleadd", { "prompt": inputVal }, config);

        dispatch({
            type: GENERATE_GOOGLEAD_SUCCESS,
            payload: {
                headlines: data.headline.choices,
                descriptions: data.desc.choices,
                websiteURL,
                adDesc
            },
        })

        // localStorage.removeItem('googleAd');

        // localStorage.setItem('googleAd', JSON.stringify({
        //     headlines: data.headline.choices,
        //     descriptions: data.desc.choices,
        //     websiteURL
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_GOOGLEAD_FAIL,
            payload: error.message,
        })
    }
}

const saveGoogleAd = (headlineChoices, descChoices, websiteURL,adDesc) => async (dispatch) => {
    dispatch({
        type: GENERATE_GOOGLEAD_SUCCESS,
        payload: {
            headlines: headlineChoices,
            descriptions: descChoices,
            websiteURL,
            adDesc
        },
    })

    // localStorage.setItem('googleAd', JSON.stringify({
    //     headlines: headlineChoices,
    //     descriptions: descChoices,
    //     websiteURL
    // }))
}

const genrateAmazonDesc = (productDesc) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_AMAZONDESC_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/generation/description", { "prompt": productDesc }, config);

        dispatch({
            type: GENERATE_AMAZONDESC_SUCCESS,
            payload: data.choices
        })

        // localStorage.removeItem('amazondesc');
        // localStorage.setItem('amazondesc', JSON.stringify({
        //     resultData: data.choices,
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_AMAZONDESC_FAIL,
            payload: error.message,
        })
    }
}

const saveAmazonDesc = (data) => async (dispatch) => {
    dispatch({
        type: GENERATE_AMAZONDESC_SUCCESS,
        payload: data
    })

    // localStorage.setItem('amazondesc', JSON.stringify({
    //     resultData: data,
    // }))
}

const genrateBlogOutline = (blogTitle, blogDesc) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_BLOGOUTLINE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        let inputVal = blogTitle + " " + blogDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/blog-outline", { "prompt": "Blog title: "+blogTitle +"\nBlog description: "+blogDesc}, config);

        dispatch({
            type: GENERATE_BLOGOUTLINE_SUCCESS,
            payload: {
                resultData: data.choices,
                blogTitle,
                blogDesc
            }
        })

        // localStorage.removeItem('tagline');

        // localStorage.setItem('tagline', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_BLOGOUTLINE_FAIL,
            payload: error.message,
        })
    }
}


const generateBlogIdeas = (blogDesc) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_BLOGIDEAS_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/blog-idea", { "prompt": blogDesc}, config);

        dispatch({
            type: GENERATE_BLOGIDEAS_SUCCESS,
            payload: {
                resultData: data.choices,
              
                blogDesc
            }
        })

        // localStorage.removeItem('tagline');

        // localStorage.setItem('tagline', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_BLOGIDEAS_FAIL,
            payload: error.message,
        })
    }
}


const saveBlogIdeas = ( resultData, blogDesc) => async (dispatch) => {
    dispatch({
        type: GENERATE_BLOGIDEAS_SUCCESS,
        payload: {
            resultData,
           
            blogDesc
        }
    })

    // localStorage.setItem('tagline', JSON.stringify({
    //     resultData,
    //     companyName
    // }))
}


const generateBlogQuote = (blogTitle, blogDesc) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_BLOGQUOTE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        // let inputVal = blogTitle + " " + blogDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        
        const { data } = await Axios.post("/generation/blog-quote", { "prompt": "Blog title: "+ blogTitle+ "\nBlog description: "+ blogDesc}, config);

        
        dispatch({
            type: GENERATE_BLOGQUOTE_SUCCESS,
            payload: {
                resultData: data.choices,
                blogTitle,
                blogDesc
            }
        })

        // localStorage.removeItem('tagline');

        // localStorage.setItem('tagline', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_BLOGQUOTE_FAIL,
            payload: error.message,
        })
    }
}

const saveBlogQuote = (blogTitle, resultData, blogDesc) => async (dispatch) => {
    dispatch({
        type: GENERATE_BLOGQUOTE_SUCCESS,
        payload: {
            resultData,
            blogTitle,
            blogDesc
        }
    })

    // localStorage.setItem('tagline', JSON.stringify({
    //     resultData,
    //     companyName
    // }))
}


const generateBlogIntro = (blogTitle, blogDesc) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_BLOGINTRO_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        // let inputVal = blogTitle + " " + blogDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/blog-intro", { "prompt": "Blog title: "+ blogTitle+ "\nBlog description: "+ blogDesc}, config);

        
        dispatch({
            type: GENERATE_BLOGINTRO_SUCCESS,
            payload: {
                resultData: data.choices,
                blogTitle,
                blogDesc
            }
        })

        // localStorage.removeItem('tagline');

        // localStorage.setItem('tagline', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_BLOGINTRO_FAIL,
            payload: error.message,
        })
    }
}

const saveBlogIntro = (blogTitle, resultData, blogDesc) => async (dispatch) => {
    dispatch({
        type: GENERATE_BLOGINTRO_SUCCESS,
        payload: {
            resultData,
            blogTitle,
            blogDesc
        }
    })

    // localStorage.setItem('tagline', JSON.stringify({
    //     resultData,
    //     companyName
    // }))
}


const generateDisplayAds = (topic) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_DISPLAYADS_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        // let inputVal = blogTitle + " " + blogDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/display-ads", { "prompt": topic}, config);

        
        dispatch({
            type: GENERATE_DISPLAYADS_SUCCESS,
            payload: {
                resultData: data.choices,
                topic
            }
        })

        // localStorage.removeItem('tagline');

        // localStorage.setItem('tagline', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_DISPLAYADS_FAIL,
            payload: error.message,
        })
    }
}


const saveDisplayAds = (resultData, topic) => async (dispatch) => {
    dispatch({
        type: GENERATE_BLOGINTRO_SUCCESS,
        payload: {
            resultData,
            topic
        }
    })

    // localStorage.setItem('tagline', JSON.stringify({
    //     resultData,
    //     companyName
    // }))
}

const generateFaq = (topic) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_FAQ_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        // let inputVal = blogTitle + " " + blogDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/Faq", { "prompt": topic}, config);

        
        dispatch({
            type: GENERATE_FAQ_SUCCESS,
            payload: {
                resultData: data.choices,
                topic
            }
        })

        // localStorage.removeItem('tagline');

        // localStorage.setItem('tagline', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_FAQ_FAIL,
            payload: error.message,
        })
    }
}

const saveFaq = (resultData, topic) => async (dispatch) => {
    dispatch({
        type: GENERATE_FAQ_SUCCESS,
        payload: {
            resultData,
            topic
        }
    })

    // localStorage.setItem('tagline', JSON.stringify({
    //     resultData,
    //     companyName
    // }))
}

const generatePainAgitate = (topic) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_PAINAGITATE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        // let inputVal = blogTitle + " " + blogDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/pain-agitate", { "prompt": topic}, config);

        
        dispatch({
            type: GENERATE_PAINAGITATE_SUCCESS,
            payload: {
                resultData: data.choices,
                topic
            }
        })

        // localStorage.removeItem('tagline');

        // localStorage.setItem('tagline', JSON.stringify({
        //     resultData: data.choices,
        //     companyName
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_PAINAGITATE_FAIL,
            payload: error.message,
        })
    }
}

const savePainAgitate = (resultData, topic) => async (dispatch) => {
    dispatch({
        type: GENERATE_PAINAGITATE_SUCCESS,
        payload: {
            resultData,
            topic
        }
    })

    // localStorage.setItem('tagline', JSON.stringify({
    //     resultData,
    //     companyName
    // }))
}


const genrateFacebookAdd = (companyName, adDesc, websiteURL) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GENERATE_FACEBOOKAD_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        let inputVal = companyName + " " + adDesc;
        // let inputData = { prompt: inputVal };
        // console.log(inputData)
        const { data } = await Axios.post("/generation/facebookadd", { "prompt": inputVal }, config);

        dispatch({
            type: GENERATE_FACEBOOKAD_SUCCESS,
            payload: {
                subHeading: data.subHeading.choices,
                subText: data.subText.choices,
                descriptions: data.desc.choices,
                websiteURL,
                adDesc
            },
        })

        // localStorage.removeItem('googleAd');

        // localStorage.setItem('googleAd', JSON.stringify({
        //     headlines: data.headline.choices,
        //     descriptions: data.desc.choices,
        //     websiteURL
        // }))
    } catch (error) {
        dispatch({
            type: GENERATE_FACEBOOKAD_FAIL,
            payload: error.message,
        })
    }
}

const saveFacebookAdd = (subHeadingChoices,subTextChoices, descChoices, websiteURL,adDesc) => async (dispatch) => {
    dispatch({
        type: GENERATE_FACEBOOKAD_SUCCESS,
        payload: {
            subHeading: subHeadingChoices,
            subText: subTextChoices,
            descriptions: descChoices,
            websiteURL,
            adDesc
        },
    })

    // localStorage.setItem('googleAd', JSON.stringify({
    //     headlines: headlineChoices,
    //     descriptions: descChoices,
    //     websiteURL
    // }))
}

export {
    genrateLinkedInAdd,
    saveLinkedInAd,
    genrateTagline,
    saveTagline,
    genrateGoogleAdd,
    saveGoogleAd,
    genrateAmazonDesc,
    saveAmazonDesc,
    genrateBlogOutline,
    generateBlogIdeas,
    saveBlogIdeas,
    generateBlogQuote,
    saveBlogQuote,
    generateBlogIntro,
    saveBlogIntro,
    generateDisplayAds,
    saveDisplayAds,
    generateFaq,
    saveFaq,
    generatePainAgitate,
    savePainAgitate,
    genrateFacebookAdd,
    saveFacebookAdd
}